import { Model } from 'vuex-orm';

import User from '../user/model';

export default class Comment extends Model {
  static entity = 'comments';

  static fields() {
    return {
      id: this.attr(null),
      author_id: this.attr(null),
      commentable_id: this.attr(''),
      commentable_type: this.attr(''),
      label: this.attr(''),
      text: this.attr(''),
      created_at: this.attr(''),
      updated_at: this.attr(''),

      author: this.belongsTo(User, 'author_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/comment/model.js